import { gql, useQuery } from "@apollo/client";
import { useMemo } from "react";

const GET_CUSTOMER_CONTENT_POLICY = gql`
  query getCustomerContentPolicy {
    familyCustomer {
      familyCustomerType {
        uuid
        name
      }
    }
  }
`;

const BABY_RENTAL_NAME = "ベビレンタ";

interface GetCustomerContentPolicyQuery {
  familyCustomer: {
    familyCustomerType?: {
      uuid: string;
      name?: string | null;
    } | null;
  };
}

export const useCustomerContentPolicy = (): { isBabyRental: boolean; isLoading: boolean } => {
  const { data, loading } = useQuery<GetCustomerContentPolicyQuery>(GET_CUSTOMER_CONTENT_POLICY);

  const isBabyRental = useMemo(
    () => data?.familyCustomer.familyCustomerType?.name === BABY_RENTAL_NAME,
    [data?.familyCustomer.familyCustomerType?.name],
  );

  return { isBabyRental, isLoading: loading };
};
